export default __webpack_public_path__ + "static/media/White0003.3e5e106d.png";